import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fs-6 text" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_badge = _resolveComponent("b-badge")!
  const _component_b_carousel_slide = _resolveComponent("b-carousel-slide")!
  const _component_b_carousel = _resolveComponent("b-carousel")!

  return (_openBlock(), _createBlock(_component_b_carousel, {
    ride: "carousel",
    interval: 5000,
    modelValue: _ctx.slide,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.slide) = $event)),
    controls: "",
    indicators: ""
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.restorant.products, (product) => {
        return (_openBlock(), _createBlock(_component_b_carousel_slide, {
          key: product.id,
          "img-src": product.image
        }, {
          default: _withCtx(() => [
            _createElementVNode("small", _hoisted_1, [
              _createVNode(_component_b_badge, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(product.name), 1)
                ]),
                _: 2
              }, 1024),
              _createTextVNode(),
              _hoisted_2,
              _createVNode(_component_b_badge, null, {
                default: _withCtx(() => [
                  _createTextVNode("$ " + _toDisplayString(product.price), 1)
                ]),
                _: 2
              }, 1024)
            ])
          ]),
          _: 2
        }, 1032, ["img-src"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["modelValue"]))
}